import RowText from "@/components/input-formvuelate/RowText.vue";
import { ValueType } from "@/enums/ValueType";
import type { SchemaType } from "@/models/domain/SchemaType";

export const verplichtingenSchema = {
	bkrVermelding: {
		component: RowText,
		label: "BKR-vermelding",
		valueType: ValueType.Currency as const,
	},
} satisfies SchemaType;

export const verkoopSchema = {
	waardeWoning: {
		component: RowText,
		label: "Waarde woning",
		valueType: ValueType.Currency as const,
	},
	restschuld: {
		component: RowText,
		label: "Restschuld",
		valueType: ValueType.Currency as const,
	},
} satisfies SchemaType;
